import React from "react"
import style from "./style.module.scss"
import { useTheme } from "@material-ui/core/styles"
import { NavLink, useRouteMatch } from "react-router-dom"
import SemiCircleProgressBar from "react-progressbar-semicircle"
import ComparisonDashDoubledChard from "./ComparisonDashDoubledChard"
import { Tooltip } from "@material-ui/core"
import { Info } from "@material-ui/icons"
import { useTranslation } from "react-i18next"
import { convertNumberToStringLocally } from "../../../utils"
import { useSelector } from "react-redux"
import config from "../../../config"

export default function RadialBar({ name, mainText, fullName, text, max, value, color, bg, targetVal, withNavLink, combine, dashboard }) {
  const { theme: { bgColors, borderColors, colors } } = useTheme()
  const {
    t,
    i18n: { language: i18nLanguage },
  } = useTranslation()
  const { params: { type }, url } = useRouteMatch()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const valueAfterSolution = (value * 100) / max
  const mainStyles = dashboard && {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column'
  }

  return (
    <div className={`${style.RadialBar}`} style={{ backgroundColor: combine ? bgColors.bgMuted : bgColors.bgPrimary0 }}>
      <div style={{ marginBottom: "-10%" }}>
        {!combine && <div className={`d-flex justify-content-between pb-2 align-items-center ${style.withBorder}`}>
          <h2 className={`m-0 ${style.withoutBorder} p-0`} style={{ color: colors.colorText }}>{name}</h2>
          <Tooltip title={<h6 style={{ fontSize: "15px" }}>{mainText}</h6>} className='ml-2 mr-auto'>
            <Info style={{ fill: colors.colorIcons }} />
          </Tooltip>
          {type === "texts" && <div className={`d-flex justify-content-between align-items-center ${style.textTitles}`}>
            <p className={`m-0`} style={{ color: colors.colorOn }}>{t('optional')} 1</p>
            <p className={`m-0`} style={{ color: colors.colorPositive }}>{t('optional')} 2</p>
          </div>}
        </div>}
        {(type === "single" || combine)
          ? <div className={`${style.main}`} style={{ 
             ...mainStyles
          }}>
            <div className={`${style.chartCont}`} style={{
              height: dashboard ? "200px" : "330px"
            }}>
              <div className={`${style.chart}`}>
                <div className={style.bars}>
                  {/* Just for PDF, the direction is left when download so below is the work aournd solution */}
                  {combine ? <SemiCircleProgressBar diameter={254} percentage={100 - valueAfterSolution} background={isContrast ? bgColors.bgCockpitBar : bg} stroke={isContrast ? bgColors.bgRadial : color}
                    direction="left"
                    strokeWidth={20} /> : <SemiCircleProgressBar diameter={254} percentage={valueAfterSolution} background={isContrast ? bgColors.bgRadial : color} stroke={isContrast ? bgColors.bgCockpitBar : bg}
                      strokeWidth={20} />}
                  <div className={style.progressDesc}>
                    <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`m-0 ${style.title}`}>{name}</p>
                    <p className={`m-0 ${style.percentage}`} style={{ color: colors.colorPrimary1000 }}>
                      {
                        // percentIs(value)
                        convertNumberToStringLocally(value, i18nLanguage)
                      }
                    </p>
                    <div style={{ borderColor: borderColors.borderPrimary1000 }}
                      className={`${style.maxSize} d-flex justify-content-center`}>
                      <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`m-0 ${style.zielwert}`}>
                        {t('target-value')} :</p>
                      <p className={`m-0 ${style.zielwertNum} ml-1`} style={{ color: colors.colorText }}>{targetVal}</p>
                    </div>
                  </div>
                  {combine && <span className={style.fullName}>
                    {fullName}
                  </span>}
                </div>
              </div>
            </div>
            <div className={`${style.desc} mt-5`} style={{ marginBottom: "40px", color: colors.colorText }}>
              {
                combine ?
                  <>
                    <p>
                      {text.length < 50 ?
                        <b style={{ marginRight: "600px" }}>
                          {text}
                        </b>
                        :
                        <b>
                          {text}
                        </b>}
                    </p>
                  </> :
                  <p><b>
                    {text}
                  </b></p>}
            </div>
            {combine && <div className={style.sideTextWrap}>
              {(name === t('HIX_dashboard_chartID')) && <p className={style.sideTextHIX} style={{ color: isContrast && colors.colorText }}>HIX
              </p>}
              {(name === t('CLIX_dashboard_chartID')) &&
                <p className={style.sideTextCLIX} style={{ color: isContrast && colors.colorText }}>CLIX
                </p>}
              {(name === t('FLESCH_dashboard_chartID')) &&
                <p className={style.sideTextFLESCH} style={{ color: isContrast && colors.colorText }}>  FLESCH
                </p>}
            </div>}
          </div> :
          <ComparisonDashDoubledChard seriesNames={["HIX"]} chartContent={{
            withChartTypes: true,
            withTimeInterval: true,
            withTotalOver: true
          }} chartId={name} />}
      </div>
      {withNavLink && <div className={`${style.footer}`}>
        <NavLink to={withNavLink}>
          <button style={{ color: colors.colorIcons, boxShadow: `0 0 7px 0 ${borderColors.borderPrimary200}` }}>{t("Detail view")}</button>
        </NavLink>
      </div>}
    </div>
  )
}
